var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal fade end-tour",
        attrs: { id: "modal_endtour", role: "dialog" },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-md" }, [
          _c("div", { staticClass: "modal-content" }, [
            _vm._m(0),
            _vm._m(1),
            _c("div", { staticClass: "modal-footer" }, [
              _c("div", [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn emergo-blue-button mb-30 mt-10 end-tour-footer",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: {
                      click: function ($event) {
                        return _vm.endTour()
                      },
                    },
                  },
                  [_vm._v(" Explore RAMS ")]
                ),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header center" }, [
      _c("img", {
        staticClass: "chkbox-img",
        attrs: {
          src: "/static/images/icons/endtour_checkbox.svg",
          alt: "checkbox-logo",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body" }, [
      _c("p", { staticClass: "complete-txt" }, [_vm._v("Congratulations!")]),
      _c("p", { staticClass: "body-txt sub-text" }, [
        _vm._v(
          " The tour is complete and you're ready to take RA/QA management to the next level. Review this information anytime from the RAMS Help Center or under Account Settings as Virtual Tour "
        ),
      ]),
      _c("p", { staticClass: "body-txt sub-text" }, [
        _vm._v(
          " We recommend going to Account Settings and adding Team Members to your account and exploring the new services your business is eligible for. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }